<template>
  <div class="p-front__content">
    <div
      class="p-signup"
      v-if="billingSuccess == false"
      style="margin: 80px 0px;"
    >
      <form
        class="p-signup__form"
        style="width: 80%;"
        method="PATCH"
        @submit="submitReg"
      >
        <h4 class="p-signup__form-heading">
          Billing Update
        </h4>
        <p style="text-align: center;">
          Proceed to update the device with the id
          {{ parameters.installationId }}
        </p>
        <div class="p-signup__form-content">
          <div class="row">
            <div class="form-group col-md-6">
              <label for="numberOfTimesPaymentIsMade"
                >Number of payments made</label
              >
              <input
                type="number"
                class="form-control form-control-lg"
                id="numberOfTimesPaymentIsMade"
                v-model="regParams.numberOfTimesPaymentIsMade"
                :placeholder="parameters.numbOfPayments"
              />
            </div>

            <div class="form-group col-md-6">
              <label for="monthlyRecurringChargeDate">Charge date</label>
              <date-picker
                v-model="regParams.monthlyRecurringChargeDate"
                id="monthlyRecurringChargeDate"
                class="date-upload"
                :placeholder="parameters.chargingDate"
                :default-value="new Date()"
                :disabled-date="disabledBeforeTodayAndAfterAWeek"
              ></date-picker>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-6">
              <label for="monthlyCharge">Monthly charge(NGN)</label>
              <input
                type="number"
                class="form-control form-control-lg"
                id="monthlyCharge"
                v-model="regParams.monthlyCharge"
                :placeholder="parameters.monthCharges"
                disabled
              />
            </div>
            <div class="form-group col-md-6">
              <label for="duration">Payment Duration (in Months)</label>
              <input
                type="number"
                class="form-control form-control-lg"
                id="duration"
                v-model="regParams.duration"
                :placeholder="parameters.durationss"
                @change="updateMonthlyCharge"
              />
            </div>
          </div>
          <hr />

          <div>
            <button
              type="submit"
              class="btn btn-info btn-block btn-lg p-signup__form-submit"
              @click="submitReg"
            >
              Update
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { Autocomplete, Form, FormItem } from "element-ui";
import DatePicker from "vue2-datepicker";

var getSearchParams = k => {
  var p = {};
  var LocationAddr = window.location.toString().split("?")[1];
  LocationAddr.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(s, k, v) {
    p[k] = v;
  });
  return k ? p[k] : p;
};

export default {
  name: "billing-update",
  components: {
    DatePicker
  },
  data() {
    return {
      billingSuccess: false,
      errorsResult: {},
      regParams: {
        duration: "",
        numberOfTimesPaymentIsMade: "",
        monthlyRecurringChargeDate: "",
        monthlyCharge: "",
        id: ""
      },
      parameters: {
        installationId: "",
        monthCharges: "",
        numbOfPayments: "",
        durationss: "",
        chargingDate: "",
        price: NaN
      },

      durationMonths: [
        {
          id: 6,
          name: "6 months"
        },
        {
          id: 12,
          name: "12 months"
        },
        {
          id: 24,
          name: "24 months"
        },
        {
          id: 36,
          name: "36 months"
        },
        {
          id: 60,
          name: "60 months"
        }
      ]
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    updateMonthlyCharge() {
      let calc = this.monthlyCharge;
      calc = this.parameters.price / this.regParams.duration;
      this.regParams.monthlyCharge = Math.ceil(calc).toFixed(2);
    },
    disabledBeforeTodayAndAfterAWeek(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    },
    validateReg() {
      var errors = [];
      for (let [field, value] of Object.entries(this.regParams)) {
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }

        switch (field) {
          case "duration":
            if (value === "null" || value === "NaN") {
              errors[field] = "Duration cannot be empty.";
            }
            break;
          case "monthlyRecurringChargeDate":
            if (value === "null" || value === "") {
              errors[field] = "Monthly recurring charge date cannot be empty.";
            }
            break;
          case "numberOfTimesPaymentIsMade":
            if (value === "null" || value === "NaN") {
              errors[field] = "Payment Installment cannot be empty.";
            }
            break;
          case "monthlyCharge":
            if (value === "null" || value === "NaN") {
              errors[field] = "Monthly charge cannot be empty.";
            }
            break;
          default:
            break;
        }
      }
      this.errorsResult = errors;
    },
    submitReg(e) {
      e.preventDefault();
      const keys = Object.keys(this.regParams);
      keys.forEach((key, index) => {
        if (key !== "monthlyRecurringChargeDate") {
          this.regParams[key] = parseInt(this.regParams[key]);
        } else {
          this.regParams[monthlyRecurringChargeDate] = this.regParams[
            monthlyRecurringChargeDate.toString()
          ];
        }
      });

      this.validateReg();
      var errorLength = Object.keys(this.errorsResult).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(() => {
          this.displayError = false;
        }, 3000);
        var errorMsg = Object.values(this.errorsResult).join("<br>");
        this.showErrorMsg({
          message: errorMsg
        });

        return;
      }

      const HTTP = this.$httpUtils.instance;
      const url = `/billings/${this.regParams.id}`;
      HTTP.patch(url, this.regParams)
        .then(res => {
          console.log("response", res);
          this.showSuccessMsg({ message: "Device Updated!" });
          window.history.back();
        })
        .catch(error => {
          this.showErrorMsg({ message: error.response.data.error.message });
        });
    }
  },
  mounted() {
    this.parameters.installationId = this.$route.params.installationCID;
    this.parameters.monthCharges = this.$route.params.monthlyCharge;
    this.parameters.numbOfPayments = this.$route.params.numbOfpayment;
    this.parameters.durationss = this.$route.params.pDuration;
    this.parameters.chargingDate = this.$route.params.chargeDate;
    this.parameters.price = this.$route.params.amounts;
    this.regParams.id = this.$route.params.id;
  }
};
</script>

<style scoped>
h4.p-signup__form-heading {
  font-weight: 600;
  color: #6a707e;
  border: none;
}

.date-upload {
  background: transparent;
  border-radius: 3px;
  border: none;
  width: 100%;
  height: 100%;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: #727272;
}

#state_dd {
  width: 100%;
}

#state_dd #state_dd__BV_toggle_ {
  width: 100% !important;
}

#reg_success {
  position: absolute;
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  padding: 0px;
  z-index: 999;
}

.form-group label {
  color: #424242;
}
.p-signin-a__form-heading {
  margin: 50px 175px;
  border: none;
}
input[type="email"] {
  /* background-image: url("../../assets/img/mail.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}

.p-signup__form-link:last-child {
  margin-bottom: 20px;
}
input[type="text"] {
  /* background-image: url("../../assets/img/profile2.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
input[type="phone-number"] {
  /* background-image: url("../../assets/img/smartphone-call.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
input[type="address"] {
  /* background-image: url("../../assets/img/placeholder.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
select {
  background-color: #ebeff2 !important;
  text-indent: 0px;
}
input[type="password"] {
  /* background-image: url("../../assets/img/key2.png"); */
  background-position: 7px 15px;
  background-repeat: no-repeat;
}
input[type="checkbox"] {
  height: 0rem;
  margin-right: 20px;
}
.p-signup__form-submit {
  margin-bottom: 30px;
}
</style>
  margin-right: 20px;
}
.p-signup__form-submit {
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/users/BillingUpdate.vue